import './userAgreement.less';
function UserAgreement() {
	return (
		<div className="userAgreement">
			<p className="wordSpace">
				本协议是由福建桐邦信息科技有限公司（以下简称“我们”）与您签署，福建桐邦信息科技有限公司为蜂巢灵工（下称“蜂巢灵工”、“我们”
				或“平台”）用户提供本协议约定各项技术服务，本协议具有合同效力，经用户登录平台并 确认本协议后，本协议成立并生效。
				为了更好地为您提供服务，请您在开始使用蜂巢灵工服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您，您应重点阅读。
				您承诺使用服务过程中，遵守法律法规及各项规范性文件的规定，您将以本人/本企业名
				义对使用蜂巢灵工的服务承担相应的法律责任。
			</p>
			<p className="wordSpace">
				本协议内容包括以下条款及蜂巢灵工已经发布的或将来可能发布的各类规则。所有规则
				为本协议不可分割的一部分，与协议正文具有同等法律效力。蜂巢灵工有权根据需要不定时地制定、修改本协议及各类规则，修订后的协议、规则公布后生效，对使用本服务的用户发生法律效力。若既有用户在本协议更新或新规则生效后继续使用蜂巢灵工提供的各项服务，则表明用户已充分阅读并认可和同意遵守新的协议及规则。若您拒绝接受新的协议或规则，您必须放弃使用蜂巢灵工提供的各项服务。
			</p>
			<h2>一、定义</h2>
			<p className="wordSpace">
				蜂巢灵工平台（本协议中简称“蜂巢灵工”、“我们”或“平台”）：是由我们自主研发及运营维护的集成了自研的产品及技术支持等服务的综合服务平台，为产业园区、派出所管理辖区提供安全数字化、人员信息链路化等服务。给产业园区企业与外包商提供供需对接的桥梁，解决企业用工、零工就业等诸多难题。小程序中涉及的企业用户和个人用户（注册用户以下称“您”）提供综合技术服务。
			</p>
			<h2>二、服务内容</h2>
			<p>1、蜂巢灵工平台可以为用户提供全方位技术服务，具体包括需求发布、驻场登记、协议报备、考勤登记等服务。</p>
			<p>2、蜂巢灵工可以为个人用户提供考勤登记、一键求助等服务。</p>
			<h2>三、账户注册、安全、注销</h2>
			<h3 className="wordSpace">（一）账户注册</h3>
			<p>1、您理解并同意，您应按照我们的要求完善您的身份信息以最终达到实名状态，否则将导致您无法使用我们的服务。</p>
			<p>
				2、您应遵循诚实信用、合法善意的原则，向我们提交相关注册资料，并确保注册资料/信息不违反法律法规，符合公序良俗，确保信息真实、完整、准确，不应提交任何违法或不良信息，相关资料如有变动，您应在信息变更后及时予以更新。如果因您所提供的注册资料不合法、不真实、不准确或未及时更新，从而导致相关法律责任或不利后果的，您将承担相应的法律责任及不利后果。我们有权在必要时要求核对您的有效身份信息或其他必要文件，您应积极配合，否则我们有权限制或停止向您提供部分或全部蜂巢灵工服务。
			</p>
			<h3 className="wordSpace">（二）账户安全</h3>
			<p>
				1、您注册蜂巢灵工服务账号后，应当妥善保管您的账号、密码、身份信息及各类产品/
				设备，并在您离开平台前以安全方式完成账号退出；对于因您自身原因导致账号、密码、身份信息的泄露或产品/设备遗失或因您未安全退出账号导致的损失，由您自行承担。
			</p>
			<p>
				2、您知悉并确认，您在本平台注册账号代表您可使用我们电子签在一个或多个平台进行签署协议，我们可通过电子签应用或用户在其他平台上对本服务的调用请求信息识别来自用户的各类产品或设备指示，您通过我们的电子签服务完成身份认证后，可调用您在其他平台或其关联公司通过电子签申请的且在效期限内的数字证书用于签署电子文件。您应当妥善保管处于您或应当处于您掌控下的这些产品或设备，对于这些产品或设备遗失所致的任何损失，由您自行承担。
			</p>
			<p>
				3、基于计算机端、手机端以及使用其他电子设备的用户使用习惯，我们可能在您使用具体产品时设置不同的账户登录模式及釆取不同的措施识别您的身份。
			</p>
			<p>
				4、我们可以基于账号安全风险防范的需求，设定相应的账号锁定机制，同时用户可申请锁定；我们有权锁定我们有理由认为可能涉及违法违规行为或侵犯第三方合法权益的账号;
				如您申请锁定账号，须按照我们的流程，经我们审核同意后进行锁定，我们有合理理由的情况下，可以拒绝您锁定账户的请求。
			</p>
			<p>
				5、如您发现有他人冒用或盗用您的账号及密码或存在任何其他未经合法授权之情形，或发生与蜂巢灵工账号关联的设备遗失或其他可能危及到您账号安全情形时，应立即以有效方式通知我们，向我们申请账号锁定。您理解平台对您的请求釆取行动需要合理期限，在此之前，我们对已执行的指令所导致的您的损失不承担任何责任。
			</p>
			<p>
				6、除非您本人书面提出申请或者另有法律规定或经司法裁判，且征得我们同意，否则您的平台账户、密码，不得以任何方式转让、赠与或继承（相关的法定财产权益除外）。
			</p>
			<p>
				7、我们有权了解您使用我们产品或服务的真实交易背景及目的，您应如实提供我们所需的真实、全面、准确的信息；如果我们有合理理由怀疑您提供虚假交易信息的，我们有权暂时或永久限制您所使用的产品或服务的部分或全部功能，并通过联系电话、短信、联系邮箱等方式通知您，您应及时予以关注。
			</p>
			<h3 className="wordSpace">（三）账户注销</h3>
			<p>
				1、在您需要终止使用我们的服务时，您可以申请注销您的账户，您可以联系我们的服务邮箱[lijun@tongbangtech.com],申请注销您的账户。您注销账户的行为会使您无法继续使用蜂巢灵工的相关服务，同时还可能对于该账户产生如下结果：
			</p>
			<p>（1）账号处于安全状态：账号处于正常使用状态，无被盗风险；</p>
			<p>
				（2）账号财产已结清，没有未完成和/或存在争议的服务：账号中没有资产、欠款、未
				结清的资金和虚拟权益；本账号及通过本账号接入的第三方中没有未完成和存在争议的服务；
			</p>
			<p>（3）账号权限解除：账号已解除与其他产品、网站授权登录或绑定关系；</p>
			<p>（4）账号无任何纠纷，包括投诉举报或被投诉举报。</p>
			<p className="mt1">
				2、您申请注销的蜂巢灵工账户应当处于正常状态，即您的蜂巢灵工账户的账户信息和用户信息是最新、完整、正确的，且该账户可以使用所有蜂巢灵工服务功能。账户信
				息或用户信息过时、缺失、不正确的账户、账户下有资金余额或被我们暂停或终止提供服
				务的账户不能被申请注销。注销账户后您的个人信息会保持不可被检索、访问的状态。
			</p>
			<p>
				3、您的蜂巢灵工账号不可转让、不可出借、不可继承，在您决定不再使用该账号时，
				您应按蜂巢灵工规定流程向蜂巢灵工申请注销该账号。
			</p>
			<h2>四、服务规范</h2>
			<p>
				1、您保证在使用服务过程中，不违反任何可适用的行政法规、地方法规及规章、部门规章等规范，不得违反本协议及蜂巢灵工平台相关规则，不得侵犯任何第三方的合法权益。
			</p>
			<p>
				2、您理解并同意，我们仅提供系统技术服务，不参与您与第三方的任何交易，您应承诺交易本身的真实性、合法性并承担相关风险。我们不介入您和第三方之间的交易纠纷，不承担与交易相关的任何责任，亦不对所进行交易提供任何形式的鉴定、证明服务或其他任何相关服务，不对质量、价格合理性等提供承诺或承担任何担保责任。
			</p>
			<p>
				3、如您为财税服务商的，您应与我们的合作银行或支付服务机构签订相关协议，完成支付指令发送及交易资金管理。您理解并同意，如涉及我们代发指令的，您应当与蜂巢灵工平台另行签署协议约定相应的指令代发规则，您对您发出或授权第三方发出的指令承担责任及风险，我们无需因此承担任何责任。如您对资金划转或扣款等存在疑义的，应与第三方自行协商解决。
			</p>
			<p>
				4、我们可通过以下方式接受来自您的指令：您通过您经过认证或校验的手机号码（电话、
				短信等）、联系邮箱向本系统发送的信息回复，或您通过您的账号及密码登录平台后的设置或操作，或通过接口传输，或通过您注册时作为该账户名称或者与该账户名称绑定的其他硬件、终端、软件、代号、编码、代码、其他账户名等有形体或无形体向我们发送的信息。您通过上述方式向我们发出的指令，均不可撤回或撤销，且成为我们为您提供服务的有效指令，视为您本人的指令；您应确保您的指令已获得充分授权，且不会侵害第三方的合法权益。您应当对我们执行上述指令产生的结果自行承担责任。一旦您使用本服务，您即不可撤销地授权我们在您及（或）您指定人符合指定条件或状态时，按照收到的操作指令执行对应的操作。
			</p>
			<p>
				5、我们会以电话、短信、联系邮箱等方式通知您交易进展情况以及提示您进行下一步的操作，但我们不保证您能够收到或者及时收到该等通知，且不对此承担任何后果。因此，
				您应当及时查看该等通知并进行相关操作。因您没有及时查看和对交易状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，我们不负任何责任。
			</p>
			<p>
				6、如我们有合理理由怀疑或经有关机关通知您可能涉嫌提供虚假信息、进行欺诈等违法违规行为的，我们有权根据相关国家法律法规的规定对您提供的各项信息、材料以及签署的文件信息等进行核实、査询、披露，有权通知您并锁定您名下的全部或部分账户，并拒绝向您提供服务，向有关机关提供相关信息并配合相关机关进行调査。
			</p>
			<p>
				7、若您为企业用户，贵企业因合并、解散、注销、宣告破产或倒闭，或被吊销营业执照等原因而主体资格终止的，您应于上述情况发生后及时通过书面形式告知我们，注销您的账号或终止使用该账号，因您未尽该通知义务给我们造成损失的，由您负责全部赔偿。
			</p>
			<p>
				8、您同意，若您丧失全部或部分民事权利能力或民事行为能力，我们有权根据有效法律文书（包括但不限于生效的法院判决、生效的遗嘱等）或我们认可的其他资料处置您账号内的资料。
			</p>
			<p>
				9、请您知悉并确认：根据《电子签名法》的规定下列情形不适合使用电子文书：涉及婚
				姻、收养、继承等人身关系的；涉及停止供水、供热、供气等公用事业服务的；法律、行政法规规定的不适用电子文书的其他情形。因此，您不得在平台上签订上述法律文件。如因您违反上述规定在平台签署上述协议导致协议无效的，您应自行承担法律后果，与我们无关。
			</p>
			<p>
				10、如需使用电子签相关公证服务的，您授权通过我们的电子签将您身份信息、签署的电
				子文件等同步传输至第三方公证处等出证服务方，您可以通过电子签向公证处申请出具公证书，证明电子文件自存储至公证处之日起未被篡改。
			</p>
			<h2>五、服务限制</h2>
			<p>
				1、您在使用我们服务过程中，不得自行发布、转载、传送含有下列内容之一的信息，蜂巢灵工在发现用户从事该等活动或发布信息时，有权基于蜂巢灵工的独立判断直接删
				除用户在蜂巢灵工上作出的相关信息，并停止用户对蜂巢灵工的全部或部分功能的使用（包括但不限于中止、限制用户使用蜂巢灵工服务），亦无需承担任何责任。如因此给我们或蜂巢灵工造成损失的，应当赔偿损失。
			</p>
			<p>（1）违反宪法确定的基本原则的；</p>
			<p>（2）危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的；</p>
			<p>（3）损害国家荣誉和利益的；</p>
			<p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
			<p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
			<p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
			<p>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
			<p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
			<p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
			<p>（10）以非法民间组织名义活动的；</p>
			<p>（11）含有法律、行政法规禁止的其他内容的。</p>
			<p>
				2、您理解并同意，如出现如下情形之一的，我们有权暂停、限制或拒绝向您名下蜂巢灵工账户提供全部或部分服务，您应承担所有相关法律责任，因此导致我们或我们雇员或第三方受损的，您应承担赔偿责任。我们可在合理期限内，通过电话、短信、联系邮箱等方式通知您，您应及时予以关注：
			</p>
			<p>（1）您违反了本协议相关约定；</p>
			<p>（2）您错误地将他人信息进行了实名认证或冒用他人名义注册、使用本服务；</p>
			<p>（3）您非法使用或未经授权使用他人账户交易；</p>
			<p>（4）您进行了与您或交易对方宣称的交易内容不符的交易，或不真实的交易；</p>
			<p>
				（5）您从事不法交易行为，如洗钱、恐怖融资、贩卖枪支、毒品、禁药、盗版软件、黄
				色淫秽物品及其他我们认为不得使用本服务进行交易的物品等，或提供赌博资讯或以任何方式引诱他人参与赌博，或法律、行政法规、规章、其他规范性法律文件等规定或相关法律文书要求；
			</p>
			<p>（6）您在参加市场活动时有批量注册账户、刷信用及其他舞弊等违反活动规则、违反诚实信用原则的；</p>
			<p>
				（7）您的行为侵害了第三方名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益，或您遭到他人投诉，且对方已经提供了相关证据的；
			</p>
			<p>（8）我们发现账户异常操作、异常交易，或合理怀疑交易有疑义，或有违反法律规定或本协议约定之虞的；</p>
			<p>（9）我们根据有权机关的要求进行操作；</p>
			<p>（10）其他我们基于单方判断，认为您已经违反本协议约定，或存在不适当之行为。</p>
			<p>
				3、如您申请恢复服务、解除上述限制，您应按我们要求如实提供相关资料及您的身份证明以及我们要求的其他信息或文件，以便我们进行核实，且我们有权依照自行判断来决定是否同意您的申请。我们将在审核通过后15个工作日内解除恢复服务或解除限制。
			</p>
			<p>
				4、您理解并同意，我们不对您因本条任一情况导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿。
			</p>
			<h2>六、免责声明</h2>
			<p>
				1、蜂巢灵工依照法律规定履行相关义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，蜂巢灵工不承担违约责任：因自然灾害、罢工、
				暴乱、战争、政府行为、司法行政命令等不可抗力因素；因电力供应故障、通讯网络故障等公共服务因素或任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽,
				政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足您要求的情形；在蜂巢灵工已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素；其他不可抗力情形。
			</p>
			<p>
				2、因您从事违法违规、违反本协议约定、侵犯第三方合法权益行为，导致本服务的终止,
				蜂巢灵工不承担任何责任。由于您的误操作、不当操作、委托他人代为操作导致的损失或法律后果，由您自行承担。
			</p>
			<p>
				3、在法律允许的情况下，蜂巢灵工对于与本协议有关或由本协议引起的任何间接的、
				惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、商誉损失或其他经济利益的损失），不论该等损失是如何产生的，也不论是由对本协议的违约（包括违反
				保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本协议规定的排他性救济没有达到其基本目的，也应排除蜂巢灵工对上述损失的
				责任。
			</p>
			<h2>七、隐私条款</h2>
			<p>根据法律规定，开发者仅收集实现小程序功能所必要的信息。</p>
			<p>（1）收集你的用户信息（微信昵称、头像、性别、地区）用于零时工用工安全管理。</p>
			<p>（2）收集你的位置信息，用于零时工用工考勤登记。</p>
			<p>（3）收集你的相册，用于零时工资料照片上传。</p>
			<p>（4）收集你的摄像头相关信息，用于零时工资料拍照上传。</p>
			<p>（5）收集你的手机号号码，用于零时工紧急联系方式。</p>
			<p>（6）收集你的身份证号码，用于零时工身份实名认证。</p>
			<p>（7）收集你的通讯地址，用于零时工紧急联系方式。</p>
			<p>以上信息都作为保密数据，不会以任何形式透漏到第三方。</p>
			<h2>八、知识产权</h2>
			<p>
				1、蜂巢灵工平台所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是蜂巢灵工或其内容提供者的知识产权（包括但不限于商标权、专利权、著作权），受中国和国际版权法的保护。非经蜂巢灵工或版权人书面同意，任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。
			</p>
			<p>
				2、您承诺不会进行任何破坏或试图破坏网络安全的行为，包括但不限于钓鱼，黑客，网
				络诈骗，网站或空间中含有航琳原质通过虚拟服务器对网络诈骗，网站或空间中含有或涉嫌散播：病毒、木马、恶意代码，及通过虚拟服务器对网络安全进行攻击。不会进行任何改变或试图改变我们的系统配置或破坏系统安全。不会修改、翻译、改编、出租、转许可、在信息网络上传播或转让我们提供的软件或服务，也不会逆向工程、反编译或试图以第三方式发现我们提供的系统软件源代码。
			</p>
			<p>
				3、我们有权独立判断您对服务功能的使用行为是否符合网络安全及系统安全要求，该等行为给我们系统带来危害，或影响我们与国际互联网或者特定网络、服务器及内部的通畅联系。我们有权随时中断该功能而无须通知您；如给我们造成损失的，您还应承担赔偿责任。
			</p>
			<h2>九、违约责任</h2>
			<p>
				1、如因您违反有关法律、法规、规章、其他规范性文件，或本协议项下的任何条款，或侵害第三方权利而给蜂巢灵工及其他用户造成损失的，您应当承担由此给蜂巢灵工及其他用户造成的损害赔偿责任。
			</p>
			<p>2、如因蜂巢灵工的技术瑕疵导致损失的，蜂巢灵工承担的损失赔偿责任，最高不超过所收取的服务费用。</p>
			<h2>十、通知与送达</h2>
			<p>
				1、您向平台提供的的联系方式（包括您的电子邮件地址、联系电话、联系地址等）应保持有效且处于可联系状态，如您联系方式发生变更的，您有义务及时更新有关信息，并保持可联系状态。否则平台存储的您最后一次提供的联系方式即视为您的有效联系方式；您的平台账号如可正常接收平台推送信息、系统消息、查看平台公告、公示的，也属于有效联系方式；因您未及时更新联系方式而导致无法及时获取查看相关通知的，由您自行承担全部后果。
			</p>
			<p>
				2、平台将向您的上述有效联系方式的其中之一或其中若干送达各类通知，而此类通知的内容可能对您的权利义务产生重大的影响，请您务必及时关注。
			</p>
			<p>
				3、通知如是通过邮资预付挂号信或商业快递服务向您提供的联系地址发出的，则以交邮后的第三个自然日或收件人实际收到之日中较早的日期作为送达日。
			</p>
			<p>4、通知如是通过电子邮件发出的，则应自系统显示电子邮件发送成功时即视为送达。</p>
			<p>
				5、通知如是以除电子邮件以外的其他电子形式发出的，包括但不限于在平台公告、公示、
				向您提供的联系电话发送手机短信，向您的账号发送弹窗消息、系统消息等，在平台使用的设备显示发送/设置成功后即视为送法。
			</p>
			<h2>十一、法律适用与管辖</h2>
			<p>1、本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。</p>
			<p>2、如因本协议或蜂巢灵工服务所引起或与其有关的任何争议均应向本协议签订地上海市青浦区人民法院提起诉讼。</p>
			<h2>十二、其他</h2>
			<p>1、本协议所有条款的标题仅为阅读方便，不作为本协议含义解释或限制的依据。</p>
			<p>2、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其他条款的有效性和可执行性。</p>
		</div>
	);
}

export default UserAgreement;
